import { Station, useGetStations } from "@/entities/station";
import { useApiClient } from "@/infrastructure/rest";
import { LangsteRouteDto } from "@/shared/types";
import { useQuery } from "@tanstack/react-query";

const LANGSTE_ROUTE_QUERY_KEY = "langste-route";

export function useGetStationsOnLangsteRoute(treinserieOfNummer: string | undefined) {
    const { data: stations, isPending: stationsPending, error } = useGetStations();
    const apiClient = useApiClient();

    return useQuery({
        queryKey: [LANGSTE_ROUTE_QUERY_KEY, treinserieOfNummer],
        queryFn: async () => {
            return await apiClient.get<LangsteRouteDto>(`/langsteroutes/${treinserieOfNummer}`);
        },
        enabled: !!treinserieOfNummer && !stationsPending && error === null,

        select: (data) => {
            if (!data) return null;
            return {
                serie: data.treinserie,
                stations:
                    data?.routepunten
                        .toSorted((a, b) => a.volgNummer - b.volgNummer)
                        .flatMap((routepunt) => {
                            const station = stations?.find((station) => station.code.toLowerCase() === routepunt.stationCode.toLowerCase());
                            return station ? Station.withActiviteitSoort(station, routepunt.activiteitSoort) : [];
                        })
                        .filter((s) => s.activiteitSoort === "AankomstEnVertrek") ?? [],
            };
        },
    });
}
